import { render, staticRenderFns } from "./UserInterest.vue?vue&type=template&id=e471bc4e"
import script from "./UserInterest.vue?vue&type=script&lang=js"
export * from "./UserInterest.vue?vue&type=script&lang=js"
import style0 from "./UserInterest.vue?vue&type=style&index=0&id=e471bc4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports